import { ReferentialKey } from 'api/referential';
import { useAppDispatch } from 'app/hooks';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { getMultipleReferentialsByKeys } from 'features/referentials/slices/getMultipleReferentialsByKeysThunk';
import { Network } from 'lucide-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Écran « Catalogue › Branches ».
 *
 * Les branches sont un référentiel : elles se lisent depuis le store, comme dans les
 * écrans Produits et Contrats de groupe. Seules leurs garanties se gèrent ici.
 */
export default function BranchesView() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getMultipleReferentialsByKeys([ReferentialKey.Branch]));
  }, [dispatch]);

  return (
    <SimpleDashboardContent>
      <GenericViewHeader title="Branches" icon={Network} />
      <Outlet />
    </SimpleDashboardContent>
  );
}
